import React from 'react'
import { string, bool } from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import MdSearch from 'react-icons/lib/md/search'
import MdRefresh from 'react-icons/lib/md/refresh'
import { loadingStatus, className } from './RefreshUtils'
import { addressBasedSearch } from '../../../store/Actions/MapActions'
import './styles/RefreshSearchButton.css'

const SearchIcon = ({ loading, theme }) =>
  loading ? (
    <MdRefresh color={theme} className={loadingStatus(loading)} />
  ) : (
    <MdSearch color={theme} />
  )

const RefreshButton = ({
  cssClass,
  loading,
  toggleStatus,
  theme,
  refreshMap,
  listShow,
  children,
  history,
  center,
  radius,
  category,
  coordParams,
  addressBasedSearch,
}) =>
  !toggleStatus &&
  !listShow && (
    <button
      className={className(cssClass)}
      onClick={() => {
        addressBasedSearch(false)
        history.push(`/${coordParams}/${category.join(',')}/${radius}`)
      }}
    >
      <SearchIcon theme={theme} loading={loading} />
      {children}
    </button>
  )

RefreshButton.propTypes = {
  cssClass: string,
  loading: bool.isRequired,
  theme: string.isRequired,
  listShow: bool.isRequired,
}

const mapStateToProps = ({ signsState, ui, spi, map }) => ({
  loading: signsState.loading,
  toggleStatus: ui.searchContentFooter,
  theme: spi.theme,
  listShow: ui.listShow,
  center: map.center,
  radius: map.radius,
  category: spi.category,
  coordParams: map.coordParams,
})

const actions = {
  addressBasedSearch: addressBasedSearch,
}

export default withRouter(
  connect(
    mapStateToProps,
    actions
  )(RefreshButton)
)



// WEBPACK FOOTER //
// ./src/components/Elements/RefreshSearchButton/index.jsx